import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { rollback } from '../../effects/rollback';
import { snackbarUndoDefault } from '../../../../../../../snackbarsStack/effects/variantUndo/snackbarUndoDefault';
import { SNACKBAR_BOARD_CARD_PREFIXES_ID } from '../../../constants';
import { getMessages } from '../../../../../../../../../store/constants';
import { getDefaultActionEvent } from '../../../../../../../snackbarsStack/effects/helpers/getDefaultActionEvent';
import { SNACKBAR_BUTTON_OK, SNACKBAR_BUTTON_UNDO } from '../../../../../../../snackbarsStack/effects/constants';
import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { toggleEnabledCardNumber } from '../effects/toggleEnabledCardNumber';

export const onShowSnackbar = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return new Promise<void>(resolve => {
            const actionApply = () => {
                return resolve();
            };

            const actionUndo = () => {
                return dispatch(rollback()).then(() => {
                    dispatch(toggleEnabledCardNumber(boardId));
                    return resolve();
                });
            };

            dispatch(snackbarUndoDefault({
                id: SNACKBAR_BOARD_CARD_PREFIXES_ID,
                text: getMessages().getText('cardNumber.modal.remove.snackbar'),
                timer: null,
                buttons: [
                    {
                        onClick: () => {
                            dispatch(getDefaultActionEvent(SNACKBAR_BOARD_CARD_PREFIXES_ID, actionUndo));
                        },
                        text: SNACKBAR_BUTTON_UNDO
                    },
                    {
                        onClick: () => {
                            dispatch(getDefaultActionEvent(SNACKBAR_BOARD_CARD_PREFIXES_ID, actionApply));
                        },
                        text: SNACKBAR_BUTTON_OK,
                        isPrimary: true
                    },
                ]
            }));
        });
    };
    return action;
};
